import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";

const VenezuelaMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		venezuelaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/south_america.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexVenezuela.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const venezuelaMapObject = loaded.venezuelaMapObject.default;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				baseMapObject={venezuelaMapObject}
				states={null}
				mapIndex={mapIndex}
				baseIcon={false} // Pass a tiny map svg/js object here, or false to disable
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				mapHighlightDisabled={true}
				mapId="base"
				maxHeight={600} // 400 for US map
				moeMode={false}
				subtractFromHeight={100} // 360 for US map
				wideMap={false} // true for US map
				// actions
				clearMap={actions.clearMap}
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default VenezuelaMapLoader;
